import { getProductBySlug } from '../api/fetchProducts';
import { setLoading } from '../store/features/common';
import store from '../store/store';

export const loadProductBySlug = async ({ params, request }) => {
  try {
    store.dispatch(setLoading(true));
    const product = await getProductBySlug(params?.slug, { signal: request?.signal });
    store.dispatch(setLoading(false));
    if (!product) {
      throw new Response('Product not found', { status: 404 });
    }
    return { product };
  } catch (err) {
    store.dispatch(setLoading(false));
    throw err;
  }
};
